import { ArrowRight } from "lucide-react";
import { Reveal, SplitLines } from "./motion";

const CHAPTERS = [
  { n: "01", title: "Hospedagem", old: "Contratar servidor, criar conta no cPanel, subir arquivo por FTP.", now: "Cole o HTML. Pronto — já está hospedado." },
  { n: "02", title: "DNS & SSL", old: "Apontar DNS, esperar propagar, brigar com certificado.", now: "Link HTTPS na hora. Domínio próprio quando quiser." },
  { n: "03", title: "Edição", old: "Abrir o código pra trocar um preço. Ou pagar alguém por cada ajuste.", now: "Clique no texto e digite. Igual editar um documento." },
  { n: "04", title: "Page builders", old: "Não aceitam HTML pronto. Você refaz tudo do zero, bloco por bloco.", now: "O Lowpages foi feito pra HTML de IA." },
];

export const Pain = () => (
  <section data-testid="pain-section" className="relative py-28 sm:py-36 px-6">
    <div className="mx-auto max-w-7xl grid lg:grid-cols-12 gap-14">
      <div className="lg:col-span-5">
        <div className="lg:sticky lg:top-32">
          <Reveal y={16} className="eyebrow mb-8">A dor</Reveal>
          <SplitLines
            as="h2"
            inView
            className="font-display font-bold tracking-[-0.03em] leading-[1] text-4xl sm:text-5xl lg:text-6xl text-[var(--ink)]"
            lines={["Gerou a página", "na IA.", <span className="text-slate-400">E agora?</span>]}
          />
          <Reveal delay={0.3} className="mt-8 text-slate-600 text-base sm:text-lg max-w-md leading-relaxed">
            O HTML está perfeito na tela do chat. Entre ele e um link no ar existe um abismo de infraestrutura que ninguém devia precisar atravessar.
          </Reveal>
          <Reveal delay={0.4} className="mt-10 inline-flex items-center gap-3 rounded-full bg-[var(--orange)]/10 border border-[var(--orange)]/30 px-4 py-2 text-sm font-semibold text-[var(--orange)]">
            Campanha não espera. Publicado em 3 min ⚡
          </Reveal>
        </div>
      </div>
      <ol className="lg:col-span-7 flex flex-col divide-y divide-slate-200">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.n} delay={i * 0.05} data-testid={`pain-chapter-${c.n}`} className="group grid sm:grid-cols-[72px_1fr] gap-4 sm:gap-8 py-10 first:pt-0">
            <span className="font-mono text-sm text-slate-400 pt-1">{c.n}</span>
            <div>
              <h3 className="font-display font-semibold text-xl sm:text-2xl text-[var(--ink)]">{c.title}</h3>
              <p className="mt-3 text-slate-400 line-through decoration-slate-300 decoration-2 leading-relaxed">{c.old}</p>
              <p className="mt-3 flex items-start gap-3 text-[var(--ink)] font-medium text-lg leading-snug">
                <ArrowRight size={20} className="mt-1 shrink-0 text-[var(--blue)] transition-transform duration-500 group-hover:translate-x-1.5" />
                {c.now}
              </p>
            </div>
          </Reveal>
        ))}
      </ol>
    </div>
  </section>
);
